/* Strona „Day 14” (04.11.2026): pasek na telefonie od sekcji produktu do boxu, przewijanie do boxu, zdarzenia Clarity.
   Bez logiki koszyka: przyciski tylko przewijają do #buy (box hm-nn-buy). */
(function () {
  function ev(n) { try { if (window.clarity) window.clarity('event', n); } catch (e) {} }
  function box() { return document.getElementById('buy') || document.getElementById('buy-sheet'); }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-d14-cta]');
    if (!a) return;
    var t = box();
    ev('d14_cta_' + a.getAttribute('data-d14-cta'));
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
  var bar = document.querySelector('[data-d14-bar]');
  var start = document.getElementById('d14-product');
  if (!bar || !start || !('IntersectionObserver' in window)) return;
  var past = false, boxVisibleOrPast = false;
  function upd() { bar.hidden = !(past && !boxVisibleOrPast); }
  new IntersectionObserver(function (es) {
    es.forEach(function (x) { past = x.boundingClientRect.top < 0; }); upd();
  }).observe(start);
  function watchBox() {
    var t = box();
    if (!t) return setTimeout(watchBox, 400);
    new IntersectionObserver(function (es) {
      es.forEach(function (x) { boxVisibleOrPast = x.isIntersecting || x.boundingClientRect.top < 0; }); upd();
    }).observe(t);
  }
  watchBox();
  ['d14-women', 'faq', 'd14-last'].forEach(function (id) {
    var el = document.getElementById(id);
    if (!el) return;
    var seen = false;
    new IntersectionObserver(function (es) { if (!seen && es[0].isIntersecting) { seen = true; ev('d14_view_' + id.replace('d14-', '')); } }).observe(el);
  });
})();
